import { Reducer } from "redux";
import { AnswerMode } from "models/AiResearch";
import { AiResearchActions } from "./actions";

interface TalkModeEntry {
  talkId: string;
  mode: AnswerMode;
}

export interface AiResearchState {
  talkModes: TalkModeEntry[];
}

const initialState: AiResearchState = {
  talkModes: []
};

const MAX_TALK_MODES = 100;

export const aiResearch: Reducer<AiResearchState, AiResearchActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "aiResearch/SET_TALK_MODE": {
      const updated = [
        ...state.talkModes.filter(h => h.talkId !== action.payload.talkId),
        { talkId: action.payload.talkId, mode: action.payload.mode }
      ];
      return {
        ...state,
        talkModes: updated.slice(-MAX_TALK_MODES)
      };
    }
    case "aiResearch/REMOVE_TALK_MODE":
      return {
        ...state,
        talkModes: state.talkModes.filter(h => h.talkId !== action.payload)
      };
    case "aiResearch/CLEAR_STATE":
      return { ...initialState };
    default:
      return state;
  }
};
